import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import { capitalize } from 'lodash';
import React from 'react';
import { Icon } from '../../Icon';
import { InputSizes, ValidationStates } from '../enums';
import styles from './BaseInput.scss';
export var getContainerClasses = function getContainerClasses(inputSize, validationState, disabled) {
  var _classnames;

  return classnames(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.defaultSize, inputSize === InputSizes.Default), _defineProperty(_classnames, styles.smallSize, inputSize === InputSizes.Small), _defineProperty(_classnames, styles.largeSize, inputSize === InputSizes.Large), _defineProperty(_classnames, styles.successState, validationState === ValidationStates.Success), _defineProperty(_classnames, styles.errorState, validationState === ValidationStates.Error), _defineProperty(_classnames, styles.disabledState, disabled), _classnames));
};

var createBaseInput = function createBaseInput(type, size) {
  var BaseInputElement = function BaseInputElement(props, ref) {
    var inputSize = capitalize(props.size) || size;
    var containerStyle = getContainerClasses(inputSize, props.validationState, props.disabled);

    var createChangeHandler = function createChangeHandler(callback) {
      return callback && function (e) {
        return callback(e.target.value);
      };
    };

    var inputProps = {};

    if (props.value !== undefined && props.value !== null && props.value !== '') {
      inputProps = Object.assign(inputProps, {
        value: props.value
      });
    }

    if (props.defaultValue) {
      inputProps = Object.assign(inputProps, {
        defaultValue: props.defaultValue
      });
    }

    return React.createElement("div", {
      className: classnames(containerStyle, props.className)
    }, React.createElement("input", Object.assign({
      className: classnames(styles.input, props.inputClassName),
      "data-test": props.dataTest,
      disabled: props.disabled,
      id: props.id,
      maxLength: props.maxLength,
      minLength: props.minLength,
      onBlur: createChangeHandler(props.onBlur),
      onChange: createChangeHandler(props.onChange),
      onFocus: props.onFocus,
      onKeyDown: props.onKeyDown,
      onKeyUp: props.onKeyUp,
      onPaste: props.onPaste,
      placeholder: props.placeholder,
      ref: ref,
      required: props.required,
      type: type,
      min: props.min,
      max: props.max,
      name: props.name
    }, inputProps)), props.validationState && React.createElement("span", {
      className: styles.iconWrapper
    }, props.validationState === ValidationStates.Success && React.createElement(Icon, {
      className: styles.icon,
      icon: "status-success"
    }), props.validationState === ValidationStates.Error && React.createElement(Icon, {
      className: styles.icon,
      icon: "status-error"
    })));
  };

  BaseInputElement.displayName = "Input.".concat(type, ".").concat(size);
  return React.forwardRef(BaseInputElement);
};

export function createBaseInputNamespace(type) {
  return Object.assign(createBaseInput(type, InputSizes.Default), {
    Default: createBaseInput(type, InputSizes.Default),
    Small: createBaseInput(type, InputSizes.Small),
    Large: createBaseInput(type, InputSizes.Large)
  });
}